import { InteractionType } from '@azure/msal-browser';
import { isEmbedded } from '../util';

export const DefaultAuthInteractionType = isEmbedded()
  ? InteractionType.Popup
  : InteractionType.Redirect;

export const AuthRequest = {
  loginHint:
    new URLSearchParams(window.location.search).get('userEmailId') ?? '',
  scopes: [`${process.env.REACT_APP_MSAL_CLIENT_ID}/.default`],
};
